// https://github.com/Kitware/paraview-glance/blob/77ece0e5272e27923b83686fafa6c6a9a419debe/src/io/ReaderFactory.js#L273-L300
// https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
const importBase64Dataset = (dataURI: string) => {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataURI.split(',')[1])
  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length)
  const dw = new DataView(ab)
  for (let i = 0; i < byteString.length; i++) {
    dw.setUint8(i, byteString.charCodeAt(i))
  }
  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString })
}

export default importBase64Dataset